import {regEn} from './regEn'

export const regRu: typeof regEn = {
  finishTitle: 'Завершение регистрации',
  company: 'Компания',
  companyPl: 'Название вашей компании',
  enter: 'Войти в систему',
  companyErr: 'Укажите название вашей компании',
  exampleProject: 'Пример проекта',
  exampleBoard: 'Моя доска',
  exampleColumn1: 'Новые',
  exampleColumn2: 'В работе',
  exampleColumn3: 'Готово',
  companyLinkInviteText:
    'Или разошлите эту ссылку своим коллегам для быстрой регистрации',
  projectParticipants: 'Участники проекта',
  workerEmail: 'e-mail сотрудника',
  notDistributed: 'Нераспределённые по проектам сотрудники',
  cantRegisterEmail: 'Ошибка регистрации',
  companyLabel: 'Выберите название для вашей компании',
  companyPlaceholder: 'Название компании',
  usernameLabel: 'Ваше имя',
  usernamePlaceholder: 'Введите имя',
  phoneLabel: 'Ваш контактный телефон',
  phonePlaceholder: 'Введите телефон',
  failSignInWithGoogle: 'Не удалось войти с помощью Google',
  accountDisabledGoogle: 'Аккаунт удален',
  stopwatchSticker: 'Секундомер',
  sprintSticker: 'Спринт',
  priorSticker: 'Приоритет',
  criticalPrio: 'critical',
  majorPrio: 'major',
  normalPrio: 'normal',
  minorPrio: 'low',

  taskTypeSticker: 'Тип задачи',
  taskTypeStickerStFeature: 'Вёрстка',
  taskTypeStickerStBug: 'Баг',

  sectionSticker: 'Раздел',
  commentSticker: 'Комментарий',
  deviceSticker: 'Устройство',
  mobDeviceSticker: 'Mobile',
  webDeviceSticker: 'Web',
  mobWebDeviceSticker: 'Mobile&Web',
  estimationSticker: 'Оценка в днях',

  boardDevTitle: 'Фрилансер',
  boardDevCol1: 'Бэклог',
  boardDevCol2: 'В работе',
  boardDevCol3: 'Готово',

  boardDev: {
    // col1 Бэклог
    boardDevCol1Task1Title: 'Карта магазинов',
    boardDevCol1Task1Sub1Title: 'адреса магазинов на карте',
    boardDevCol1Task1Sub2Title: 'плавный переход при изменении масштаба',
    boardDevCol1Task1Sub3Title: 'ползунки для выбора диапазона значений',
    boardDevCol1Task2Title: 'Калькулятор стоимости',
    boardDevCol1Task3Title: 'Валидация формы',
    boardDevCol1Task3Sub1Title: 'Подключение формы обратной связи',

    // col2 В работе
    boardDevCol2Task1Title: 'Анимация на первом экране не работает',
    /* boardDevCol2Task2Title: 'Подключение формы обратной связи', */
    /* boardDevCol2Task2Sub1Title: 'Валидация формы', */

    boardDevCol2Task3Title: 'Вёрстка главной страницы',

    boardDevCol2Task3Sub1Title: 'Верстка хэдера и футера',
    boardDevCol2Task3Sub2Title: 'Создание адаптива',
    boardDevCol2Task3Sub3Title:
      'Оптимизация превью для различных разрешений экрана',

    // col3 Готово
    boardDevCol3Task1Title: 'Подготовка ТЗ',
    boardDevCol3Task2Title: 'Встреча с заказчиком',
    boardDevCol3Task3Title: 'Настройка кабинета web-мастера',
    boardDevCol3Task4Title: 'Тёмная тема: фикс теней при переключении',
    boardDevCol3Task5Title: 'Интеграция библиотеки шрифтов',
    boardDevCol3Task6Title:
      'Неправильное отображение данных при входе на мобильном по ссылке-приглашению',
    boardDevCol3Task7Title: 'Всплывающая подсказка для иконки превью',
    boardDevCol3Task8Title: 'Полноэкранное отображение панели с фильтрами',
    inProgressMoveTemplate: 'В работу'
  },

  boardTeamTitle: 'Сайт для зоомагазина',
  boardTeamCol1: 'Входящие задачи',
  boardTeamCol2: 'Дизайн',
  boardTeamCol3: 'Тестирование',
  boardTeamCol4: 'Готово',

  boardTeam: {
    col1Task1Title: 'Авторизация пользователя по номеру телефона',
    col1Task2Title: 'Фильтры по каталогу',
    col1Task3Title: 'Уведомления об изменениях в личном кабинете',
    col1Task4Title: 'Ссылка-приглашение по реферальной программе',
    col1Task5Title: 'Создание страницы профиля в ЛК',
    col1Task6Title: 'Просмотр товаров в корзине',
    col1Task7Title: 'Отрисовка диаграммы "Здоровье вашего питомца"',
    col1Task8Title: 'Настройка аватарки в аккаунте',

    col2Task1Title: 'Обложка с котиком',
    col2Task2Title: 'Прототип каталога',

    col3Task1Title: 'Уведомления о изменении данных на email',
    col3Task2Title: 'Не работает компонент отображения маршрута',
    col3Task2Sub1Title:
      'правильность входных данных, которые должны передаваться в компонент отображения маршрута (координаты, маршруты, точки)',
    col3Task2Sub2Title: 'Настройка конфигурации компонента',
    col3Task3Title: 'Bubble chart',

    bugTemplate: 'Баг'
  }
}
